module.exports = __webpack_public_path__ + "media/images/royalslider/c-7ac449891c29213278da890a52d12fce.jpg";